import React from 'react';
import { Button, Stack } from '@mui/material';
import { Entry } from '../App';
import { createEntry } from '../utils/createEntry';

interface Props {
  entries: Entry[];
  setEntries: React.Dispatch<React.SetStateAction<Entry[]>>;
}

const JsonImportExport: React.FC<Props> = ({ entries, setEntries }) => {
  const handleExportJSON = () => {
    const minimalData = entries.map(entry => ({
      qrText: entry.qrText,
      markdownText: entry.markdownText,
    }));

    const blob = new Blob([JSON.stringify(minimalData, null, 2)], {
      type: 'application/json',
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'entries.json';
    link.click();
    URL.revokeObjectURL(url);
  };

  const handleImportJSON = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const text = await file.text();
    try {
      const parsed: { qrText: string; markdownText: string }[] = JSON.parse(text);

      const sanitizedEntries: Entry[] = await Promise.all(
        parsed.map(({ qrText, markdownText }) => createEntry(qrText, markdownText))
      );

      setEntries(sanitizedEntries);
    } catch (err) {
      console.error('Invalid JSON file:', err);
    }
  };

  return (
    <Stack direction="row" spacing={2}>
      <Button disabled={entries.length===0} variant="outlined" onClick={handleExportJSON}>
        Export JSON
      </Button>
      <Button variant="outlined" component="label">
        Import JSON
        <input
          type="file"
          accept="application/json"
          hidden
          onChange={handleImportJSON}
        />
      </Button>
    </Stack>
  );
};

export default JsonImportExport;
